import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LayoutSidebarService } from '../../../shared/services/layout-sidebar.service';
import { AppSidebarComponent } from '../app-sidebar/app-sidebar.component';
import { BackdropComponent } from '../backdrop/backdrop.component';
import { AppHeaderComponent } from '../app-header/app-header.component';

@Component({
  selector: 'app-layout',
  imports: [
    CommonModule,
    RouterModule,
    AppHeaderComponent,
    AppSidebarComponent,
    BackdropComponent
  ],
  templateUrl: './app-layout.component.html',
})

export class AppLayoutComponent {
  readonly isExpanded;
  readonly isHovered;
  readonly isMobileOpen;
  readonly isFullscreen;
  readonly isFullscreenOpen;

  constructor( public sidebarService: LayoutSidebarService ) {
    this.isExpanded = this.sidebarService.isExpanded;
    this.isHovered = this.sidebarService.isHovered;
    this.isMobileOpen = this.sidebarService.isMobileOpen;
    this.isFullscreen = this.sidebarService.isFullscreen;
    this.isFullscreenOpen = this.sidebarService.isFullscreenOpen;
  }

  get containerClasses() {
    return [
      'flex-1',
      'transition-all',
      'duration-300',
      'ease-in-out',
      (this.isExpanded() || this.isHovered()) ? 'xl:ml-[290px]' : 'xl:ml-[90px]',
      this.isMobileOpen() ? 'ml-0' : ''
    ];
  }

}
